import React, { Suspense, useState, useEffect, useRef } from "react";
import { ProjectStatusDrawer } from "../../AssetLinking/StatusDrawers";
import systemListingService from "./SystemListingServices";

export default function ProjectStatusListing(param: any) {
  const [editingOn, setEditingOn] = useState(false);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerMode, setDrawerMode] = useState<"add" | "edit">("add");
  const [editingRowId, setEditingRowId] = useState<number | null>(null);

  const [projectStatus, SetprojectStatus] = useState<any>([]);


  useEffect(() => {

    if (param.activeTab === "Project Status") {
      projectStatusSelect()
    }
  }, [param])


  const projectStatusSelect = () => {

    var payload = {}
    systemListingService.projectStatusList(payload).then((res:any) => { SetprojectStatus(res) })

  }

  const openAddDrawer = () => {
    if (!editingOn) return;
    setDrawerMode("add");
    setEditingRowId(null);
    setDrawerOpen(true);
  };

  const closeDrawer = () => {
    setDrawerOpen(false);
  };

  const handleDeleteRow = (rowId: number) => {

  };


  return (
    <div className="content-card ws-12">
      {/* Edit tab */}
      <div className="ptl pbl ws-12">
        <span className="text-bold">Project Status</span>
        <button className="icon-btn info pull-right" type="button" onClick={() => setEditingOn((prev) => !prev)}  >
          {editingOn ? "Edit Mode: On" : "Edit Mode: Off"}
        </button>

      </div>

      {/* Table */}
      <div className="table-wrapper">
        <table className={editingOn ? "editing-on newTable" : "newTable"}  >
          <thead>
            <tr>
              <th style={{ width: "18%" }}>Project Status ID</th>
              <th className="col-status text-center">Project Status Name</th>
              <th style={{ width: "18%" }}>Operations</th>
            </tr>
          </thead>
          <tbody>
            {projectStatus.map((row: any) => (
              <tr key={row.statusID}>
                <td>{row.statusID}</td>
                <td className="text-center"> {row.statusDescription} </td>
                <td >
                  <div className="ops-cell">
                    <button className="icon-btn edit" type="button" disabled={!editingOn}>
                      <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" >
                        <path d="M12 20h9" />
                        <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z" />
                      </svg>
                    </button>

                    <button className="icon-btn delete" type="button" disabled={!editingOn} onClick={() => handleDeleteRow(row.id)}>
                      <i className="icon-trash"> </i>
                    </button>
                  </div>
                </td>

              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="add-row-wrapper">
        <button className="btn-add-row" type="button" onClick={openAddDrawer} disabled={!editingOn}>
          <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" >
            <line x1="12" y1="5" x2="12" y2="19" />
            <line x1="5" y1="12" x2="19" y2="12" />
          </svg>
          Add Project Status
        </button>
        <button
          id="tableSaveBtn"
          className="btn-save-table"
          type="button"
          disabled={!editingOn}
          onClick={() => {
            setEditingOn(false);
          }}
        >
          Save Changes
        </button>
      </div>
      {/* 

      <ProjectStatusDrawer
        open={drawerOpen}
        mode={drawerMode}
        form={drawerForm}
        onClose={closeDrawer}
        onReset={resetDrawerFields}
        onSave={handleSaveDrawer}
        onFieldChange={updateDrawerField}
      /> */}

    </div>
  );
};

